import styled from '@emotion/styled';
import '../../../assets/colors.scss';
import { typography } from 'src/theme/typography';
const ItineraryPageStyle = styled('div')`
    line-height: 1.4;
    min-height: 700px;
    .btn-choose-image {
        color: var(--orange-300);
        border-color: var(--orange-300);
        margin-bottom: 16px;
    }

    .carousel-box {
        .slick-prev,
        .slick-next {
            opacity: 0.65;
            &::after {
                border-inline-width: 5px 0;
                border-block-width: 5px 0;
            }
            &:hover {
                opacity: 1;
            }
        }
    }

    .carousel-item {
        position: relative;
        vertical-align: middle;
        &::before {
            display: block;
            content: '';
            width: 100%;
            padding-top: 50%;
        }
        img {
            right: 0;
            width: 100%;
            height: 100%;
            bottom: 0;
            left: 0;
            top: 0;
            position: absolute;
            object-fit: cover;
            border-radius: 6px;
        }
    }

    .card {
        border-radius: 6px;
        background: var(--white);
        border: 1px solid var(--sand-400);
        padding: 24px;
        margin: 16px 0;

        .title-card {
            color: var(--sand-700);
            ${typography.subhead}
            margin-bottom: 16px;
        }

        .itinerary-title-card {
            color: var(--sand-700);
            font-size: 20px;
            font-weight: 700;
            line-height: normal;
            letter-spacing: -0.03em;
            margin-bottom: 10px;
            .icon-top {
                color: var(--orange-300);
                margin-top: 4px;
            }
        }

        .why-book {
            font-size: 14px;
            .item {
                display: flex;
                align-items: flex-start;
                gap: 12px;
                padding: 6px 0;

                .icon-check {
                    color: var(--orange-300);
                    margin-top: 3px;
                }
            }
        }
    }

    .please-read {
        padding: 24px 16px;
        ${typography.bodyMd}

        .sub-card {
            color: var(--sand-700);
            ${typography.bodyL}
            margin-bottom: 16px;
        }

        .please-box {
            margin-bottom: 16px;
            .name {
                font-weight: 700;
                font-size: 20px;
                letter-spacing: -0.03em;
                margin-bottom: 16px;
            }
            ul {
                list-style-type: disc;
                padding-left: 24px;
                li {
                    margin-bottom: 8px;
                }
            }
            a {
                word-wrap: break-word;
                text-decoration-line: underline;
            }
        }
    }

    .main-image::before {
        padding-top: 30% !important;
    }

    @media screen and (max-width: 767px) {
        .card {
            padding: 16px;
        }
    }

    @media print {
        .card {
            break-inside: avoid;
            page-break-inside: avoid;
            margin-top: 24px;
        }
    }
`;
export default ItineraryPageStyle;

export const SupplierCommentStyle = styled('div')`
    background-color: var(--sand-100) !important;
    line-height: 1.5;
`;